<template>
  <popConfirmButton
    :ok-text="$t('xia-jia')"
    :cancel-text="$t('qu-xiao')"
    class="card-btn-offline"
    type="primary"
    @confirm="confirm"
  >
    <template #title>
      {{
        $t(
          'shang-jia-gai-mo-ban-hou-suo-you-yong-hu-jiang-ke-yi-cha-kan-shi-yong-que-ren-shi-fou-shang-jia',
        )
      }}
    </template>
    <template #default>
      {{ $t('xia-jia') }}
    </template>
  </popConfirmButton>
</template>

<script lang="ts" setup>
import popConfirmButton from './pop-confirm-button.vue';

const ctx: any = inject('personal-page-ctx');
const cardItem = inject('card-item');

const confirm = () => {
  if (cardItem) {
    ctx.actionToggleOnline(cardItem);
  } else {
    ctx.actionToggleOnline();
  }
};
</script>

<style lang="scss">
.card-btn-offline {
  flex: 1;
  border-radius: 6px;
}
</style>
